import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { Rating } from '../../../StarRating/components/Rating';

export function StarRating({ props }: StructuredContentDocument) {
  const { rating } = props;
  return (
    <Rating
      value={rating}
      size="19px"
      gap="5px"
      additionalStyles={{ marginRight: '5px', marginY: '3px' }}
    />
  );
}
